import { memo, useEffect } from "react";
import { Routes as RoutesWrapper, Route } from "react-router-dom";
import '../style.css';
import { Users, Roles, ChangePassword, ServiceTypes, ServiceCategories, HomePage, ProvidersRR, ProvidersRRDetails, ProviderProfile, DoctorDetails, DoctorReport, CreateDoctor, MedicalRequest, PatientRequestDetails, AddQuotation, Admission, PostServiceEntry, BrokerRegistration, PatientsListGroups } from "@pages/Exporter";
import MedicalRequests from "@/pages/broker/requests/medical/requests";
import AccountManagerMedicalRequests from "@/pages/accountManager/medical/requests";
import PatientCaseFile from "@/pages/accountManager/medical/PatientCase";
import { useLocation } from "react-router-dom";
import QuotationProcess from "@/pages/accountManager/medical/QuotationProcess";
import AccountManagerMedicalReports from "@/pages/accountManager/medical/Reports";
import ACMQuotationDetailsPage from "@/pages/accountManager/medical/QuotationFinalize";
import QuotationDetailsPage from "@/pages/broker/requests/medical/quotationDetails";
import MedicalRequestDetails from "@/pages/broker/requests/medical/requestDetails";
import RequestMissingData from "@/pages/broker/requests/medical/RequestMissingData";

const AuthedRoutes = () => {




const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <RoutesWrapper>
      <Route path="panel/*" element={
        <RoutesWrapper>
          <Route path="/" element={<HomePage />} />
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="service-types" element={<ServiceTypes />} />
          <Route path="service-category" element={<ServiceCategories />} />
          <Route path="providers-request" element={<ProvidersRR />} />
          <Route path="request-details/:id" element={<ProvidersRRDetails />} />
          <Route path="provider-profile" element={<ProviderProfile />} />

          <Route path="provider/doctors" element={<DoctorReport />} />
          <Route path="provider/doctors/create" element={<CreateDoctor />} />
          <Route path="provider/doctors/details/:doctorId" element={<DoctorDetails />} />
          <Route path="provider/requests/medical" element={<MedicalRequest />} />
          <Route path="provider/medical-request/:id/:statusId" element={<PatientRequestDetails />} />
          <Route path="provider/medical-request/add-quotation" element={<AddQuotation />} />
          <Route path="provider/medical-request/admission" element={<Admission />} />
          <Route path="provider/medical-request/post-service-entry" element={<PostServiceEntry />} />
          
          <Route path="broker/registration" element={<BrokerRegistration />} />
          <Route path="broker/clients/report" element={<PatientsListGroups />} />
          <Route path="broker/medical-requests" element={<MedicalRequests />} />
          <Route path="broker/medical-requests/:medicalOrderId" element={<MedicalRequestDetails />} />
          <Route path="broker/medical-requests/:medicalOrderId/missing-data" element={<RequestMissingData />} />
          <Route path="broker/medical-requests/:medicalOrderId/quotation/:hospitlaOrderId" element={<QuotationDetailsPage />} />

          <Route path="account-manager/medical-requests" element={<AccountManagerMedicalRequests />} />
          <Route path="account-manager/medical-reports" element={<AccountManagerMedicalReports />} />
          <Route path="account-manager/medical-reports/:id" element={<PatientCaseFile />} />
          <Route path="account-manager/medical-requests/:id/:medicalOrderId" element={<QuotationProcess />} />
          <Route path="account-manager/medical-requests/:id/:medicalOrderId/:hospitalRequestId" element={<ACMQuotationDetailsPage />} />

        </RoutesWrapper>
      } />
    </RoutesWrapper>
  );
};

export default memo(AuthedRoutes);